import { z } from "zod";

// Define the Zod schema for user group validation
export const userGroupSchema = z.object({
  name: z.string().min(1, "Le nom du groupe est requis"),
  description: z.string().optional(),
});

// Infer the TypeScript type from the schema
export type UserGroupFormValues = z.infer<typeof userGroupSchema>;

export const defaultValues: UserGroupFormValues = {
  name: "",
  description: "",
};
